import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-loader__content" }

import {
  onMounted,
  onBeforeUnmount,
  reactive,
  computed,
} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLoader',
  props: {
    absolute: { type: Boolean },
    noShadow: { type: Boolean },
    noBackground: { type: Boolean },
    color: { default: '#38383A' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "8d18cdd8": (_ctx.color)
}))

library.add(faSpinner);

const props = __props;

const header = reactive({
  $el: null as null | HTMLElement,
});
const minHeight = reactive({ value: null as number | null });
const minHeightPx = computed(() => (minHeight.value ? `min-height:${minHeight.value}px` : undefined));

const setMinHeight = () => {
  minHeight.value = window.innerHeight;

  if (header.$el) {
    minHeight.value -= header.$el.offsetHeight;
  }
};

onMounted(() => {
  header.$el = document.querySelector('header');

  if (props.absolute) return;

  window.addEventListener('resize', setMinHeight);
  window.addEventListener('load', setMinHeight);
  setMinHeight();
  for (let i = 100; i < 3000; i += 100) {
    setTimeout(setMinHeight, i);
  }
});

onBeforeUnmount(() => {
  if (props.absolute) return;

  window.removeEventListener('resize', setMinHeight);
  window.removeEventListener('load', setMinHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-loader", {
        absolute: _ctx.absolute,
        'no-shadow': _ctx.noShadow,
        'no-background': _ctx.noBackground,
      }])
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(minHeightPx.value)
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_FontAwesomeIcon, {
              icon: "fa-light fa-spinner",
              class: "fa-pulse"
            })
          ]),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ], 4)
  ], 2))
}
}

})